import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File, IWriteOptions, FileEntry } from '@ionic-native/file/ngx';
import { DialogService } from '../../_services/dialog.service';

@Component({
  selector: 'app-multipart-file-upload',
  templateUrl: './app-multipart-file-upload.component.html'
})
export class AppMultipartFileUploadComponent implements OnInit {
  index ;
  @Input() options: any = {};
  @Input() acceptedTypes: any = "image/*,.pdf,.csv,.xls,.xlsx,.doc,.docx,.rtf";
  @Output() fileEncoded = new EventEmitter();
  @ViewChild('fileInput', {static: false}) fileInput !: ElementRef;
  constructor(private sanitizer: DomSanitizer,
    private platform: Platform,
    private camera: Camera,
    //private dialogService: DialogService,
    private file: File) { }

    @Input() acceptedFiles  = [
    'application/pdf',
    'text/csv',
    'text/plain',
    'image/png',
    'image/jpeg',
    'image/jpg',
    'application/vnd.ms-excel', // xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //xlxs
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //docx
    'application/msword', //doc and rtf
    'application/zip', //zip
    'application/x-zip-compressed', //zip
  ]
  //acceptedTypes = "image/*,.pdf,.csv,.xls,.xlsx,.doc,.docx,.rtf";
  //fileSizeInMegaByte = 1024*1024;

  ngOnInit() { }

  openFileSelection(index) {
    //console.log(parseInt(index));
    this.index = index;
    const inputElement: HTMLElement = this.fileInput.nativeElement as HTMLElement;
    inputElement.click();
  }

  selectFile(event) {
    if (!this.platform.is('cordova')) {
      this.onFileChange(event);
      return;
    }
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    };
    this.camera.getPicture(options).then((imageData) => {
      this.file.resolveLocalFilesystemUrl(imageData).then((entry: FileEntry) => {
        entry.file(file => {
          this.readFile(file);
        });
      });
    }, (err) => {
      console.log(err);
    });
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.readFile(event.target.files[0]);
    }
  }

  readFile(file: any) {
    const fileType = file.type.toLowerCase();
    //let fileSizeInBytes: number =file.size;
    console.log('fileType :',fileType);
    // if ((fileType.indexOf('pdf') !== -1) || (fileType.indexOf('image') !== -1) || (fileType.indexOf('csv') !== -1) || (fileType.indexOf('xlsx') !== -1) || (fileType.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') !== -1)) {
    // if( this.acceptedFiles.includes(fileType) || (fileType.indexOf('image') !== -1)) {
    if( this.acceptedFiles.includes(fileType)) {
      // if((fileSizeInBytes <= this.megaByte)){

        this.fileEncoded.emit({fileData:file, index: this.index});
      // }
      // else{
      //   this.dialogService.showMessageDialog('File size cannot Exceed 1MB');
      //   this.clearFile();
      // }
    } else {
      this.clearFile();
    }
  }

  clearFile() {
    const inputElement: HTMLInputElement = this.fileInput.nativeElement as HTMLInputElement;
    inputElement.value = '';
  }

}
